import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMomentPropType } from '../../lib/customPropTypes';
import moment from 'moment';
import classnames from 'classnames';
import { isSameDay, isDayDisabled } from '../../lib/dateUtils';

export default class Day extends Component {

  static defaultProps = {
    utcOffset: moment.utc().utcOffset()
  }

  static propTypes = {
    day: PropTypes.object.isRequired,
    highlighted: PropTypes.func,
    month: PropTypes.number,
    onClick: PropTypes.func,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date),
      isMomentPropType,
    ]),
    utcOffset: PropTypes.number
  }

  constructor(props, context) {
    super(props, context);
    this.getClassNames = this.getClassNames.bind(this);
    this.isHighlighted = this.isHighlighted.bind(this);
    this.isWeekend = this.isWeekend.bind(this);
    this.isOutsideMonth = this.isOutsideMonth.bind(this);
    this.handleClick = this.handleClick.bind(this);

  }

  getClassNames () {
    return classnames('calendar_day', {
      'calendar_day--disabled': isDayDisabled(this.props.day, this.props),
      'calendar_day--selected': isSameDay(this.props.day, this.props.selected),
      'calendar_day--highlighted': this.isHighlighted(),
      'calendar_day--today': isSameDay(this.props.day, moment.utc().utcOffset(this.props.utcOffset)),
      'calendar_day--weekend': this.isWeekend(),
      'calendar_day--outside-month': this.isOutsideMonth()
    });
  }

  isHighlighted () {
    if (this.props.highlighted) {
      return this.props.highlighted(this.props.day);
    }
    return false;
  }

  isWeekend () {
    return this.props.day.day() === 0 || this.props.day.day() === 6;
  }

  isOutsideMonth () {
    return this.props.month !== undefined &&
      this.props.month !== this.props.day.month();
  }

  handleClick (event) {
    if (!isDayDisabled(this.props.day, this.props) && this.props.onClick) {
      this.props.onClick(event);
    }
  }

  render () {
    return (
      <td onClick={this.handleClick}>
        <span className={this.getClassNames()}
          data-testid={isSameDay(this.props.day, moment.utc().utcOffset(this.props.utcOffset)) ? 'today' : undefined}>
          {this.props.day.date()}
        </span>
      </td>
    );
  }

}
